import { Navigate } from 'react-router-dom';

const index = {
  path: "/",
  element: <Navigate from="/" to="/dashboard" exact replace />,
}

export default index